import moment from 'moment'

import { mapObject } from 'lib/object/objectUtils'
import { GetTripDocumentsResponse } from 'tripPlanner/api/documents/types'
import { TripDocumentsResult } from 'tripPlanner/hooks/api/documents'
import { TripDocument } from 'tripPlanner/types/documents'

type APIDocument = GetTripDocumentsResponse['result']['unAttachedFiles'][number]

export function mapTripDocument(document: APIDocument): TripDocument {
  return {
    filename: document.key.replace(/^.*\//, ''),
    size: document.size,
    lastModified: moment(document.lastModified),
    key: document.key,
  }
}

export function mapTripDocuments(
  documents: GetTripDocumentsResponse['result'],
): TripDocumentsResult {
  return {
    attachedFiles: mapObject(documents.attachedFiles, (files) =>
      files.map(mapTripDocument),
    ),
    unAttachedFiles: documents.unAttachedFiles.map(mapTripDocument),
  }
}
